import { createContext, useContext } from 'react';

export const ClinicalNoteContext = createContext();

export const useClinicalNoteContext = () => useContext(ClinicalNoteContext);
